import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

/**
 * RegistryApiClientService — shared low-level HTTP transport over the Registry API.
 * Evidence: docs/discovery/03-api-contracts-and-mappers.md — Candidate Mapper/Adapter Boundaries
 *
 * Responsibilities:
 * - configure base URL from environment token (injected by each app's providers)
 * - attach auth headers via HTTP interceptor pattern
 * - expose typed GET/POST/PUT/DELETE helpers used by adapter layers
 *
 * What does NOT belong here:
 * - Angular Router redirects
 * - dialog/snackbar services
 * - Office.js or Word APIs
 * - domain model hydration (use domain/analysis-mappers)
 */
@Injectable({ providedIn: 'root' })
export class RegistryApiClientService {
  readonly #http = inject(HttpClient);

  get<T>(path: string, params?: HttpParams): Observable<T> {
    return this.#http.get<T>(path, { params });
  }

  post<T>(path: string, body: unknown): Observable<T> {
    return this.#http.post<T>(path, body);
  }

  put<T>(path: string, body: unknown): Observable<T> {
    return this.#http.put<T>(path, body);
  }

  delete<T>(path: string): Observable<T> {
    return this.#http.delete<T>(path);
  }
}
